import axios from 'axios';

export function init(apiBase) {

	window.submitFormWithRecaptcha = () => {		
		const formData = new FormData();

		const email = document.querySelector('.newsletter-signup input[name="email"]').value;
		const name = document.querySelector('.newsletter-signup input[name="name"]').value;
		const country = document.querySelector('.newsletter-signup select[name="country"]').value;
		const postcode = document.querySelector('.newsletter-signup input[name="postcode"]').value;
		const about = document.querySelector('.newsletter-signup select[name="about"]').value;		

		const form = document.querySelector('.newsletter-signup');

        if (form.checkValidity()) {
			formData.append('sourceType', 'Linn Website');
			formData.append('sourceSubType', 'Footer Subscription');
			formData.append('system', 'Linn Website');
			formData.append('email', email);
			formData.append('fullname', name);
			formData.append('country', country);
			formData.append('postcode', postcode);
			formData.append('aboutMe', about);
			formData.append(
				"gRecaptchaResponse",
				document.querySelector('.newsletter-signup .g-recaptcha-response').value
			)
		
			axios({
				method: 'post',
				url: apiBase + 'users/subscriptions',
				data: formData,
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
			})
				.then(function (response) {	
					document.querySelector('.col.-newsletter .step-1').classList.remove('-visible');
					document.querySelector('.col.-newsletter .step-2').classList.add('-visible');
					fbq('trackCustom', 'SignUpToEmailList');
					gtag('event', 'SignUpToEmailList', {
						event_category: 'Forms',
						event_action: 'Submit',
						event_label: 'SignUpToEmailList'
					});
				})
				.catch(function (error) {	
					console.log(error);
				});
		} else {
			form.reportValidity();
			grecaptcha.reset();
			return;
		}
	};
}